import { render, staticRenderFns } from "./playRemind.vue?vue&type=template&id=512571f4&scoped=true&"
import script from "./playRemind.vue?vue&type=script&lang=js&"
export * from "./playRemind.vue?vue&type=script&lang=js&"
import style0 from "./playRemind.vue?vue&type=style&index=0&id=512571f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512571f4",
  null
  
)

export default component.exports